export class IngestionPipelineDeadLetter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dlqPath",
            "baseName": "dlqPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceUri",
            "baseName": "sourceUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "etag",
            "baseName": "etag",
            "type": "string",
            "format": ""
        },
        {
            "name": "byteRange",
            "baseName": "byteRange",
            "type": "IngestionPipelineDeadLetterByteRange",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordsDecoded",
            "baseName": "recordsDecoded",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "occurredAt",
            "baseName": "occurredAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineDeadLetter.attributeTypeMap;
    }
    constructor() {
    }
}
